/**
 * LineClamp Component
 * Simple text clamping component using CSS -webkit-line-clamp
 */

import React, { HTMLAttributes } from 'react';

type LineClampProps = HTMLAttributes<HTMLDivElement> & {
    clampLines?: number;
    showTitle?: boolean;
    children: React.ReactNode;
};

const LineClamp: React.FC<LineClampProps> = ({ 
    clampLines = 1, 
    showTitle = false,
    children,
    style,
    ...restProps 
}) => {
    const clampStyle: React.CSSProperties = {
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: clampLines,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style
    };

    const textContent = typeof children === 'string' ? children : undefined;
    const titleProp = showTitle && textContent ? { title: textContent } : {};

    return (
        <div 
            style={clampStyle}
            {...titleProp}
            {...restProps}
        >
            {children}
        </div>
    );
};

export default React.memo(LineClamp);

